import request from "../assets/js/axios";
import request2 from '../request';

export const {
  get: getApi,
  post: postApi,
} = request;

export const {
  post: postRequest,
  get: getRequest
} = request2